import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
} from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import {
  PermissionInfo,
  NotificationInfo,
  UserInfo,
} from "../../../../../context";

const MerchantEmployeeEditBooking = ({
  open,
  close,
  selectedData,
  activeServiceList,
  getMerchantOrderSaveList,
  selectedBookService,
  setSelectedBookService,
}) => {
  //   console.log("selectedBookService: ", selectedBookService);
  const [form] = Form.useForm();
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [selectedBooked, setSelectedBooked] = useState(
    selectedData !== null && selectedData.is_booked
  );
  const [selectedBookedCategory, setSelectedBookedCategory] = useState(
    selectedData !== null && selectedData.booked_category
  );
  const [selectedMethod, setSelectedMethod] = useState(
    selectedData !== null && selectedData.downpayment_method
  );
  const { rerunNotif } = useContext(NotificationInfo);
  const { permissionList } = useContext(PermissionInfo);

  const handleEditBookedService = (values) => {
    const formdata = new FormData();
    formdata.append("down_cashier_id", userData.data.id);
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append(
      "service_type",
      selectedBookService !== null && selectedBookService.service_type
    );
    formdata.append(
      "service_duration_unit",
      selectedBookService !== null &&
        selectedBookService.service_type === "duration"
        ? selectedBookService !== null && selectedBookService.service_duration
        : ""
    );
    formdata.append(
      "consumable_qty",
      selectedBookService !== null &&
        selectedBookService.service_type === "consumable"
        ? 1
        : ""
    );
    formdata.append(
      "table_no",
      selectedBookService !== null && selectedBookService.service
    );
    formdata.append(
      "description",
      selectedBookService !== null && selectedBookService.service_desc
    );
    formdata.append(
      "price",
      selectedBookService !== null && selectedBookService.srp
    );
    formdata.append(
      "transaction_id",
      selectedData !== null && selectedData.transaction_id
    );
    formdata.append(
      "final_started_date",
      moment(new Date(values.started_date)).format("YYYY-MM-DD HH:mm")
    );
    formdata.append(
      "ended_date",
      moment(new Date(values.started_date))
        .add(
          values.service_duration,
          selectedBookService !== null &&
            selectedBookService.service_duration === "hour"
            ? "hours"
            : selectedBookService !== null &&
              selectedBookService.service_duration === "day"
            ? "days"
            : "months"
        )
        .format("YYYY-MM-DD HH:mm")
    );
    formdata.append("payment_method", "cash");

    formdata.append(
      "cost_per_prod",
      userData.data.usersmerchantemployee.perproductcost !== null
        ? parseInt(selectedBookService.service_charge_exempted) !== 1
          ? (userData.data.usersmerchantemployee.perproductcost.percentage /
              100) *
            selectedBookService.srp
          : 0
        : 0
    );
    formdata.append(
      "allow_housekeeping",
      permissionList.data.store_permission.find(
        ({ permission }) => permission === "allow-house-keeping"
      )
        ? "yes"
        : "no"
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    // setLoading(true);
    axios
      .post("user/merchant/update/booked-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Update booked service successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Edit Booked Service"
      width={300}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <>
          <Form
            form={form}
            layout="vertical"
            name="edit-booked-service2"
            initialValues={{
              service: parseInt(selectedData.product_id),
              customer_name: selectedData.customer_name,
              is_booked: parseInt(selectedData.is_booked),
              booked_category: selectedData.booked_category,
              downpayment: selectedData.downpayment,
              downpayment_method: selectedData.downpayment_method,
              edown_noncash: selectedData.edown_noncash,
              edownpayment: selectedData.edownpayment,
              edown_ref_no: selectedData.edown_ref_no,
              service_duration: selectedData.service_duration,
              started_date: moment(selectedData.started_date),
            }}
            onFinish={handleEditBookedService}
            autoComplete="off"
          >
            <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
              <Form.Item
                name="service"
                label="Service Name"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                {/* {console.log("activeServiceList", activeServiceList)} */}
                <Select
                  placeholder="Select"
                  size="large"
                  onChange={(e) => {
                    const value = activeServiceList.data.filter(
                      (res) => res.id === e
                    );
                    setSelectedBookService(value[0]);

                    setSelectedBooked(null);
                    setSelectedBookedCategory(null);
                    setSelectedMethod(null);

                    form.setFieldsValue({
                      is_booked: null,
                      booked_category: null,
                      downpayment_method: null,

                      edown_noncash: null,
                      downpayment: null,
                      edownpayment: null,
                      edown_ref_no: null,
                    });
                  }}
                >
                  {activeServiceList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        {permissionList.data.store_permission.find(
                          ({ permission }) =>
                            permission === "allow-house-keeping"
                        ) && data.service_type !== "one-time" ? (
                          <div
                            style={{
                              width: 10,
                              height: 10,
                              backgroundColor:
                                data.service_status_abbreviation === "VR"
                                  ? "green"
                                  : data.service_status_abbreviation === "VC"
                                  ? "orange"
                                  : data.service_status_abbreviation === "VD"
                                  ? "red"
                                  : "gray",
                              marginRight: 5,
                              borderRadius: 5,
                            }}
                          />
                        ) : null}
                        {data.service_type === "consumable"
                          ? `${data.service} - ${data.srp}`
                          : data.service_type === "duration"
                          ? `${data.service} - ${data.srp}/${data.service_duration}`
                          : `${data.service} - ${data.srp}/person`}
                      </span>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="customer_name"
                label="Customer Name"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set Customer Name" size="large" />
              </Form.Item>

              {/* {console.log("selectedBookService: ", selectedBookService)} */}

              {selectedBookService !== null &&
                selectedBookService.service_type !== "one-time" && (
                  <Form.Item
                    name="is_booked"
                    label="Is Booked?"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      size="large"
                      onChange={(e) => {
                        setSelectedBooked(e);
                      }}
                    >
                      <Select.Option value={1}>Yes</Select.Option>
                      <Select.Option value={0}>No</Select.Option>
                    </Select>
                  </Form.Item>
                )}

              {parseInt(selectedBooked) === 1 &&
                selectedBookService !== null &&
                selectedBookService.service_type !== "one-time" && (
                  <>
                    <Form.Item
                      name="booked_category"
                      label="Booked Category"
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select"
                        size="large"
                        onChange={(e) => {
                          setSelectedBookedCategory(e);
                        }}
                      >
                        <Select.Option value={"pencil-booking"}>
                          Pencil Booking
                        </Select.Option>
                        <Select.Option value={"booking"}>Booking</Select.Option>
                      </Select>
                    </Form.Item>

                    {selectedBookedCategory === "booking" && (
                      <>
                        <Form.Item
                          name="downpayment_method"
                          label="Downpayment Method"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select method"
                            onChange={(e) => {
                              setSelectedMethod(e);
                              // setInputtedPayment(null);
                              // setInputtedEcashPayment(null);
                              form.setFieldsValue({
                                edown_noncash: null,
                                downpayment: null,
                                edownpayment: null,
                                edown_ref_no: null,
                              });
                            }}
                            size="large"
                            showSearch
                          >
                            <Select.Option value={"enter-payment"}>
                              Cash Downpayment
                            </Select.Option>
                            <Select.Option value={"ecash-payment"}>
                              ECash Downpayment
                            </Select.Option>
                            <Select.Option value={"split-payment"}>
                              Split Downpayment
                            </Select.Option>
                          </Select>
                        </Form.Item>

                        {selectedMethod === "enter-payment" && (
                          <Form.Item
                            name="downpayment"
                            label="Cash Amount"
                            rules={[
                              {
                                required: true,
                                message: "Required",
                              },
                            ]}
                          >
                            <InputNumber
                              min={1}
                              max={999999999999}
                              initialvalues={0}
                              size="large"
                              style={{ width: "100%" }}
                              step="0.01"
                              // onChange={(value) => setInputtedPayment(value)}
                            />
                          </Form.Item>
                        )}

                        {selectedMethod === "ecash-payment" && (
                          <>
                            <Form.Item
                              name="edown_noncash"
                              label="Non-cash"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select non-cash"
                                onChange={(e) => {
                                  // setInputtedPayment(null);
                                  // setInputtedEcashPayment(null);
                                  form.setFieldsValue({
                                    downpayment: null,
                                    edownpayment: null,
                                    edown_ref_no: null,
                                  });
                                }}
                                size="large"
                                showSearch
                              >
                                <Select.Option value={"gcash"}>
                                  GCash
                                </Select.Option>
                                <Select.Option value={"gcredit"}>
                                  GCredit
                                </Select.Option>
                                <Select.Option value={"paymaya"}>
                                  Paymaya
                                </Select.Option>
                                <Select.Option value={"creditcard"}>
                                  Credit Card
                                </Select.Option>
                                <Select.Option value={"debitcard"}>
                                  Debit Card
                                </Select.Option>
                                <Select.Option value={"banktransfer"}>
                                  Bank Transfer
                                </Select.Option>
                                <Select.Option value={"cheque"}>
                                  Cheque
                                </Select.Option>
                              </Select>
                            </Form.Item>

                            <Form.Item
                              name="edownpayment"
                              label="ECash Amount"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                initialvalues={0}
                                size="large"
                                style={{ width: "100%" }}
                                step="0.01"
                                // onChange={(value) => setInputtedEcashPayment(value)}
                              />
                            </Form.Item>

                            <Form.Item
                              name="edown_ref_no"
                              label="Reference #"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Input placeholder="Set ref no" size="large" />
                            </Form.Item>
                          </>
                        )}

                        {selectedMethod === "split-payment" && (
                          <>
                            <Form.Item
                              name="downpayment"
                              label="Cash Amount"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                initialvalues={0}
                                size="large"
                                style={{ width: "100%" }}
                                step="0.01"
                                // onChange={(value) => setInputtedPayment(value)}
                              />
                            </Form.Item>

                            <Form.Item
                              name="edown_noncash"
                              label="Non-cash"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select non-cash"
                                onChange={(e) => {
                                  // setSelectedMethod(e);
                                  // setInputtedPayment(null);
                                  // setInputtedEcashPayment(null);
                                  form.setFieldsValue({
                                    downpayment: null,
                                    edownpayment: null,
                                    edown_ref_no: null,
                                  });
                                }}
                                size="large"
                                showSearch
                              >
                                <Select.Option value={"gcash"}>
                                  GCash
                                </Select.Option>
                                <Select.Option value={"gcredit"}>
                                  GCredit
                                </Select.Option>
                                <Select.Option value={"paymaya"}>
                                  Paymaya
                                </Select.Option>
                                <Select.Option value={"creditcard"}>
                                  Credit Card
                                </Select.Option>
                                <Select.Option value={"debitcard"}>
                                  Debit Card
                                </Select.Option>
                                <Select.Option value={"banktransfer"}>
                                  Bank Transfer
                                </Select.Option>
                                <Select.Option value={"cheque"}>
                                  Cheque
                                </Select.Option>
                              </Select>
                            </Form.Item>

                            <Form.Item
                              name="edownpayment"
                              label="ECash Amount"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                max={999999999999}
                                initialvalues={0}
                                size="large"
                                style={{ width: "100%" }}
                                step="0.01"
                                // onChange={(value) => setInputtedEcashPayment(value)}
                              />
                            </Form.Item>

                            <Form.Item
                              name="edown_ref_no"
                              label="Reference #"
                              rules={[
                                {
                                  required: true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <Input placeholder="Set ref no" size="large" />
                            </Form.Item>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}

              {selectedBookService !== null &&
              selectedBookService.service_type === "duration" ? (
                <Form.Item
                  name="service_duration"
                  label={`How Many ${selectedBookService.service_duration}(s)`}
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={1}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                  />
                </Form.Item>
              ) : selectedBookService !== null &&
                selectedBookService.service_type === "one-time" ? (
                <Form.Item
                  name="service_duration"
                  label={`How Many Person(s)`}
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={1}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                  />
                </Form.Item>
              ) : null}

              <Form.Item
                name="started_date"
                label="Date/Time Start"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD HH:mm"}
                  size="large"
                  style={{ width: "100%" }}
                  showTime
                />
              </Form.Item>
            </Space>

            <Form.Item style={{ marginTop: "20px" }}>
              <Button
                type="primary"
                loading={loadings}
                htmlType="submit"
                style={{ width: "100%", borderRadius: "20px" }}
              >
                {!loadings ? "Confirm" : "Loading"}
              </Button>
            </Form.Item>
          </Form>
        </>
      )}
    </Drawer>
  );
};

export default MerchantEmployeeEditBooking;
